<div>
  <ng-template #inputTemplate let-input>
    <ng-container *ngFor="let input of input.inputs || []; trackBy: trackByChecksum">
      <ng-container *ngTemplateOutlet="inputTemplate; context: { $implicit: input }"></ng-container>
    </ng-container>

    <ng-container *ngIf="!input.inputs">
      <div margin-bottom-small-x>
        <rti-field-mapping-form-field
          (formFieldChanged)="handleFormFieldChange($event)"
          [integrationName]="integrationName"
          [integrationKind]="integrationKind"
          [formConfigId]="formConfig.id"
          [formInput]="input"
          [sources]="sources"
          [sourcesLoading]="sourcesLoading"
        ></rti-field-mapping-form-field>

        <rt-divider></rt-divider>
      </div>
    </ng-container>
  </ng-template>

  <ng-container *ngIf="isDynamic()">
    <rt-placeloader *ngIf="isLoading" variant="item"></rt-placeloader>

    <rt-box layout-vertical variant="background-light no-padding" margin-tb>
      <div *ngIf="!isLoading" padding-tb-small-x padding-lr-small layout layout-align-items-center>
        <rt-icon name="label" margin-right-small-x></rt-icon>

        <rt-heading variant="subheading">
          {{ formConfig.remoteName }}

          <rt-badge
            *ngIf="formConfig.inputsCount || formConfig.inputsCount === 0"
            [text]="badgeLabel()"
            color="counter-default"
            margin-left-small-x
          >
          </rt-badge>
        </rt-heading>

        <div margin-left-auto>
          <rt-icon-button
            *ngIf="!isEditing"
            (click)="startEditing()"
            variant="plain"
            iconName="edit"
            shape="square"
          >
          </rt-icon-button>

          <rt-icon-button
            *ngIf="isEditing"
            (click)="stopEditing()"
            variant="plain"
            iconName="clear"
            shape="square"
          >
          </rt-icon-button>
        </div>
      </div>

      <ng-container *ngIf="!isLoading && isEditing">
        <rt-divider variant="line"></rt-divider>

        <rt-spinner *ngIf="isLoading" variant="small"></rt-spinner>

        <div
          *ngIf="!isLoading && (formConfig.inputsCount || !!formConfig.errors)"
          class="field-mapping-form-editable"
        >
          <rti-error-messages-wrapper
            *ngIf="!!formConfig.errors"
            [errors]="formConfig.errors"
          ></rti-error-messages-wrapper>

          <ng-container *ngFor="let input of formConfig.inputs; trackBy: trackByChecksum">
            <ng-container *ngTemplateOutlet="inputTemplate; context: { $implicit: input }">
            </ng-container>
          </ng-container>
        </div>

        <rt-infobox
          *ngIf="formConfig.inputsCount === 0"
          [isDismissible]="false"
          [iconName]="'info-outline'"
          type="transparent"
          padding-medium
          >{{
            'rti.field_mapping.settings.remote_template.no_mappable_fields' | translate
          }}</rt-infobox
        >

        <rt-divider variant="line"></rt-divider>

        <div layout-horizontal layout-space-between padding class="field-mapping-form-editable">
          <div>
            <rt-button
              (click)="delete(); $event.stopPropagation()"
              variant="plain"
              class="danger-on-hover"
            >
              <rt-icon name="remove-circle"></rt-icon>
              <span>{{ 'rti.field_mapping.settings.remove_template' | translate }}</span>
            </rt-button>
          </div>
        </div>
      </ng-container>
    </rt-box>
  </ng-container>

  <ng-container *ngIf="!isDynamic()">
    <rt-spinner *ngIf="isLoading" variant="small"></rt-spinner>

    <ng-container *ngIf="!isLoading">
      <rti-error-messages-wrapper
        *ngIf="!!formConfig.errors"
        [errors]="formConfig.errors"
      ></rti-error-messages-wrapper>

      <ng-container *ngFor="let input of formConfig.inputs || []; trackBy: trackByChecksum">
        <ng-container
          *ngTemplateOutlet="inputTemplate; context: { $implicit: input }"
        ></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
